<script>
import { userTypes, orderTypes } from "@/store/types/types.js";
import CalendarSelector from "@/components/CalendarSelector";
import SmallModal from "@/components/SmallModal";
import * as moment from "moment";
export default {
  name: "NewOrder",
  components: {
    CalendarSelector,
    SmallModal
  },
  data() {
    return {
      orderList: [],
      currentPage: {
        year: 0,
        month: 0
      },
      dates: [],
      deleteIndex: "",
      deleteSubItemIndex: -1,
      addOrderList: [],
      prepayTotal: 0,
      restPrePayNum: 0,
      prepayList: [],
      currentPrepayList: [0, 0, 0, 0, 0, 0],
      riceNum: [],
      user: {},
      undeliveredList: [],
      sameDescription: "",
      sameRice: 0,
      sameCustomerLabel: "",
      sameCustomerPrice: 0
    };
  },
  computed: {
    userList() {
      return this.$store.getters[userTypes.getters.getUserList];
    },
    userId() {
      return this.$store.getters[orderTypes.getters.getUser];
    },
    orderListInMonth() {
      return this.$store.getters[orderTypes.getters.getOrderList];
    }
  },
  methods: {
    getSameOrders() {
      //扁平化

      let flatOrderList = this.mergeAllOrder();
      flatOrderList = flatOrderList.map(order => {
        order.description = this.sameDescription;
        order.rice = this.sameRice;
        order.customized_label = this.sameCustomerLabel;
        order.customized_price = this.sameCustomerPrice;
        return order;
      });
      flatOrderList = flatOrderList.map((order, index) => {
        if (index < this.prepayTotal) {
          order.is_prepay = 1;
        } else {
          order.is_prepay = 0;
        }
        return order;
      });
      let restDescriptionItemIndex = 0;
      this.calcCurrentPrepayOrderNum();
      this.currentPrepayList.forEach((cur, cIndex) => {
        if (cur) {
          restDescriptionItemIndex = this.prepayList[cIndex];
        }
      });
      flatOrderList = flatOrderList.map((order, index) => {
        if (order.is_prepay && index >= restDescriptionItemIndex) {
          order.description = "";
        }
        return order;
      });
      let emptyDescription = flatOrderList.some(order => !order.description);
      if (emptyDescription) {
        alert("預付品項超出預付款項，請手動填入部分預付品項！");
      }
      this.turnToOrderList(flatOrderList);
      this.currentPrepayList = [0, 0, 0, 0, 0, 0];
    },
    turnToHome() {
      if (this.orderList.length !== 0) {
        confirm("新增訂單尚未完成，是否結束？")
          ? this.$router.push("/home")
          : null;
        return;
      }
      this.$router.push("/home");
    },
    sortDate(data) {
      return data.sort((a, b) => {
        let aa = a.split("-");
        let bb = b.split("-");
        return aa[0] - bb[0] || aa[1] - bb[1] || aa[2] - bb[2];
      });
    },
    clickCheckByModal() {
      // 刪除訂單
      this.orderList[this.deleteIndex].list.splice(this.deleteSubItemIndex, 1);
      this.orderList[this.deleteIndex].list.length === 0
        ? this.dates.splice(this.deleteIndex, 1)
        : null;
      this.restPrePayNum = this.restPrePayNum + 1;
      // 扁平化陣列排序
      this.flatOrderList();
      // 清除重複預付選項
      this.calcCurrentPrepayOrderNum();
      this.currentPrepayList.forEach((item, index) => {
        if (item > this.prepayList[index]) {
          this.orderList[this.deleteIndex].list[
            this.deleteSubItemIndex
          ].description = "";
        }
      });
      this.currentPrepayList = [0, 0, 0, 0, 0, 0];
    },
    passDeleteIndex(index, dIndex) {
      this.deleteIndex = index;
      this.deleteSubItemIndex = dIndex;
    },
    addOrder(index, month, date) {
      let user = this.userList.filter(user => user.id === this.userId)[0];
      let order = {
        user_id: this.userId,
        phone: user.phone.main,
        address:
          user.address.main.city +
          user.address.main.district +
          user.address.main.street,
        description: "",
        price: 0,
        rice: 0,
        customized_label: "",
        customized_price: 0,
        delivered_at: `${this.currentPage.year}-${month}-${date}`,
        is_prepay: 0
      };
      //判斷還有預付總數嗎？
      this.restPrePayNum ? (order.is_prepay = 1) : (order.is_prepay = 0);
      order.is_prepay ? (this.restPrePayNum = this.restPrePayNum - 1) : null;
      this.orderList[index].list.push(order);
      this.flatOrderList();
    },
    mergeAllOrder() {
      let flatOrderList = [];
      this.orderList.forEach(order => {
        order.list.forEach(detail => flatOrderList.push(detail));
      });
      return flatOrderList;
    },
    turnToOrderList(list) {
      //顯示畫面
      //bug
      //扁平化的 array 相同日期與不同日期的整理
      //需要測試新增份數 新增多日訂單 新增單日訂單
      //預付是否有先花玩 日期排序是否正確 份數是否有bug
      let orderAllList = this.dates.map(date => {
        return {
          month: Number(date.split("-")[1]),
          date: Number(date.split("-")[2]),
          list: []
        };
      });
      list.forEach(detail => {
        let time = detail.delivered_at.split("-");
        orderAllList.forEach(order => {
          if (
            order.date === Number(time[2]) &&
            order.month === Number(time[1])
          ) {
            order.list.push(detail);
          }
        });
      });
      //排序訂單日期
      this.orderList = orderAllList.sort((a, b) => {
        return a.month - b.month || a.date - b.date;
      });
    },
    flatOrderList() {
      //日期排序
      if (this.dates.length !== 0) {
        this.dates = this.sortDate(this.dates);
        this.dates = Array.from(new Set(this.dates));
      }
      //扁平化陣列
      let flatOrderList = this.mergeAllOrder();
      //排序訂單日期
      flatOrderList.sort((a, b) => {
        let aa = a.delivered_at.split("-");
        let bb = b.delivered_at.split("-");
        return aa[0] - bb[0] || aa[1] - bb[1] || aa[2] - bb[2];
      });
      //必須先花完預付，最早的訂單強迫改為預付
      flatOrderList = flatOrderList.map((order, index) => {
        if (index < this.prepayTotal) {
          order.is_prepay = 1;
        } else {
          order.is_prepay = 0;
          order.description = "2～3人";
        }
        return order;
      });
      flatOrderList.sort(a => {
        return a.is_prepay && a.description ? -1 : a.is_prepay ? -1 : 1;
      });

      this.turnToOrderList(flatOrderList);
    },
    removeDate(day) {
      this.dates.forEach((date, index) => {
        if (date === day) {
          this.dates.splice(index, 1);
        }
      });

      this.orderList.forEach((order, index) => {
        if (order.date === day) {
          this.orderList.splice(index, 1);
        }
      });
      this.flatOrderList();
    },
    removeDates(data) {
      data.forEach(date => {
        this.orderList.forEach((order, index) => {
          if (order.date === date) {
            this.orderList.splice(index, 1);
          }
        });
        this.dates.forEach((day, index) => {
          if (day === date) {
            this.dates.splice(index, 1);
          }
        });
      });
      this.flatOrderList();
    },
    getDate(date) {
      let monthOfDate = date.split("-")[1];
      let dayOfDate = date.split("-")[2];
      this.orderList = this.orderList.filter(day => {
        return `${day.month}-${day.date}` != `${monthOfDate}-${dayOfDate}`;
      });
      this.dates.push(date);
      let order = {
        list: [
          {
            user_id: this.user.id,
            phone: this.user.phone.main,
            address:
              this.user.address.main.city +
              this.user.address.main.district +
              this.user.address.main.street,
            description: "",
            price: 0,
            rice: 0,
            customized_label: "",
            customized_price: 0,
            delivered_at: date,
            is_prepay: 0
          }
        ]
      };
      //判斷還有預付總數嗎？
      this.restPrePayNum
        ? (order.list[0].is_prepay = 1)
        : (order.list[0].is_prepay = 0);
      order.list[0].is_prepay
        ? (this.restPrePayNum = this.restPrePayNum - 1)
        : null;
      this.orderList.push(order);
      this.flatOrderList();
    },
    getDates(data) {
      data.forEach(date => {
        this.getDate(date);
      });
    },
    getCurrentPage(data) {
      this.currentPage.year = data.year;
      this.currentPage.month = data.month;
      let date = {
        year: data.year,
        month: data.month
      };
      this.$store
        .dispatch(orderTypes.actions.GET_SINGLE_USER_ORDER_LIST, date)
        .then(res => {
          this.undeliveredList = res.undeliveredList;
          this.flatOrderList();
        });
    },
    convertToPrice(item) {
      switch (item.description) {
        case "2～3人":
          item.price = 450;
          break;
        case "2～3人優惠":
          item.price = 405;
          break;
        case "2～3人優惠（月）":
          item.price = 380;
          break;
        case "3～4人":
          item.price = 550;
          break;
        case "3～4人優惠":
          item.price = 495;
          break;
        case "3～4人優惠（月）":
          item.price = 460;
          break;
        case "自訂":
          item.price = 0;
          break;
        default:
          item.price = 0;
          break;
      }
      return item;
    },
    calcCurrentPrepayOrderNum() {
      this.orderList.forEach(order => {
        order.list.forEach(detail => {
          if (detail.is_prepay === 0) return;
          switch (detail.description) {
            case "2～3人":
              this.currentPrepayList[1] = this.currentPrepayList[1] + 1;
              break;
            case "2～3人優惠":
              this.currentPrepayList[3] = this.currentPrepayList[3] + 1;
              break;
            case "2～3人優惠（月）":
              this.currentPrepayList[5] = this.currentPrepayList[5] + 1;
              break;
            case "3～4人":
              this.currentPrepayList[0] = this.currentPrepayList[0] + 1;
              break;
            case "3～4人優惠":
              this.currentPrepayList[2] = this.currentPrepayList[2] + 1;
              break;
            case "3～4人優惠（月）":
              this.currentPrepayList[4] = this.currentPrepayList[4] + 1;
              break;
            default:
              break;
          }
        });
      });
    },
    checkPrepayOrderNum(dIndex, oIndex) {
      if (this.orderList[dIndex].list[oIndex].is_prepay === 0) return;
      this.calcCurrentPrepayOrderNum();
      this.currentPrepayList.forEach((item, index) => {
        if (item > this.prepayList[index]) {
          alert("必須先使用預付品項，已超過預付範圍，請重新選擇品項。");
          this.orderList[dIndex].list[oIndex].description = "";
        }
      });
      this.currentPrepayList = [0, 0, 0, 0, 0, 0];
    },
    toFinishAddOrder() {
      //驗證是否訂單都有選擇
      let flatOrderList = [];
      this.orderList.forEach(order => {
        order.list.forEach(detail => flatOrderList.push(detail));
      });
      let tmp = flatOrderList.every(order => order.description);
      if (!tmp) return alert("請選擇下拉選單！");
      //新增訂單
      let orderList = this.orderList.map(order => order.list);

      const rowLength = orderList.length;
      const columnLength = orderList.reduce(
        (a, b) => (a > b.length ? a : b.length),
        0
      );

      let result = [];

      for (let i = 0; i < columnLength; i++) {
        for (let j = 0; j < rowLength; j++) {
          if (orderList[j] && orderList[j][i]) {
            result.push(orderList[j][i]);
          }
        }
      }
      result.forEach(order => {
        this.convertToPrice(order);
      });
      this.$store.dispatch(orderTypes.actions.ADD_ORDER, result);

      // this.orderList.forEach(order => {
      //   let list = order.list;
      //   list.forEach((detail, index) => {
      //     this.convertToPrice(detail);
      //     this.$store.dispatch(orderTypes.actions.ADD_ORDER, detail);
      //   });
      // });
      this.$router.push("/home");
    },
    calcPrepayNum() {
      if (!this.user.prepay) return;
      this.prepayTotal = this.user.prepay.reduce((acc, cur) => {
        return Number(acc) + Number(cur);
      });
      this.restPrePayNum = this.prepayTotal;
      this.prepayList = this.user.prepay;
    }
  },
  watch: {
    userId(val) {
      this.userId = val;
    },
    undeliveredList(val) {
      this.undeliveredList = val;
    }
  },
  mounted() {
    this.$store
      .dispatch(userTypes.actions.QUERY_SINGLE_USER, this.userId)
      .then(user => {
        this.user = user;
        this.calcPrepayNum();
        this.riceNum = Array.from({ length: 30 }, (item, index) => index + 1);
      });
    let date = {
      year: Number(moment().format("YYYY")),
      month: Number(moment().format("MM"))
    };
    this.$store
      .dispatch(orderTypes.actions.GET_SINGLE_USER_ORDER_LIST, date)
      .then(res => {
        this.undeliveredList = res.undeliveredList;
      });
  }
};
</script>





<template src="./template.html"></template>
<style lang="scss" src="./style.scss" scoped />
